var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataProvider && _vm.dataProvider.imageSrc)?_c('v-img',{attrs:{"src":_vm.$icsilab.getUrlImage(_vm.dataProvider.imageSrc),"height":_vm.dataProvider.height}}):_c('fx-anomalie-composant',{attrs:{"composant":"fx-bandeau-image","propriete":"imageSrc"}})
}
var staticRenderFns = []

export { render, staticRenderFns }